import { useTranslation } from '@mc/i18n'
import EmailCapture from './EmailCapture'

const ClassSampleEmailCapture = (props) => {
  const { t } = useTranslation('@mc/next')

  return (
    <EmailCapture {...props}>
      <h2 className='mc-text-h4'>{t('emailCaptureBanner.header')}</h2>
      <p className='mc-opacity--muted mc-my-4'>
        {t('emailCaptureBanner.body')}
      </p>
    </EmailCapture>
  )
}

export default ClassSampleEmailCapture
